import { render } from "./WardGroup.vue?vue&type=template&id=0862c2de"
import script from "./WardGroup.vue?vue&type=script&lang=js"
export * from "./WardGroup.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0862c2de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0862c2de', script)) {
    api.reload('0862c2de', script)
  }
  
  module.hot.accept("./WardGroup.vue?vue&type=template&id=0862c2de", () => {
    api.rerender('0862c2de', render)
  })

}

script.__file = "src/views/Settings/WardGroup.vue"

export default script